import { getLanguage } from '@i18n/utils'
import i18nMessages from '@i18n/index'
import { IApplicationTypeList, IDeviceTypeList } from '@shared/interface/device.interface'
import { DeviceTypeEnum } from '@shared/enum/device-type.enum'
import { FingerPrintDataWebApp } from '@data/dto/fingerprintdata/fingerprintdata-webapp-dto'


/**
 * Get application type and device type strings according to the current language
 * @returns Promise<IGetTypeList | undefined>
 */
interface IGetTypeList {
  applicationTypeList?: IApplicationTypeList
  deviceTypeList?: IDeviceTypeList
}
export const getTypesList = (): Promise<IGetTypeList | undefined> => {
  return getLanguage()
    .then(language => {
      const messages = Object.keys(i18nMessages).some(m => m.toLowerCase() === language.toLowerCase()) ? i18nMessages[language.toLowerCase()] : null
      if (messages) {
        return {
          applicationTypeList: messages.mydevices.applicationType as IApplicationTypeList,
          deviceTypeList: messages.mydevices.deviceType as IDeviceTypeList,
        }
      }
    })
}

/**
 * Get device type
 * @param {FingerPrintData | undefined} fingerPrintData
 * @returns {DeviceType | undefined}
 */
export const getDeviceType = (fingerPrintData?: FingerPrintDataWebApp): DeviceTypeEnum | undefined => {
  if (fingerPrintData?.device?.type != null && fingerPrintData?.device?.type != '') {
    return convertTypeToEnum(fingerPrintData?.device.type)
  } else {
    if (fingerPrintData?.device?.isMobile != null && !fingerPrintData?.device?.isDesktop) {
      return DeviceTypeEnum.SMARTPHONE
    } else if (!fingerPrintData?.device?.isMobile && fingerPrintData?.device?.isDesktop) {
      return DeviceTypeEnum.DESKTOP
    } else {
      return DeviceTypeEnum.DESKTOP
    }
  }
}

/**
 * Convert text type to enum type
 * Possible String types : console, mobile, tablet, smarttv, wearable, embedded
 * @param {string | DeviceType} deviceType
 * @returns {DeviceType} DeviceType
 */
const convertTypeToEnum = (deviceType: string | DeviceTypeEnum): DeviceTypeEnum => {
  if (deviceType in DeviceTypeEnum) {
    return deviceType as DeviceTypeEnum
  }

  let newType:DeviceTypeEnum;
  switch(deviceType) {
    case 'console':
      newType = DeviceTypeEnum.CONSOLE
      break;
    case 'mobile':
      newType = DeviceTypeEnum.SMARTPHONE
      break;
    case 'tablet':
      newType = DeviceTypeEnum.TABLET
      break;
    case 'smarttv':
      newType = DeviceTypeEnum.SMART_TV
      break;
    case 'wearable':
      newType = DeviceTypeEnum.PORTABLE_DEVICE
      break;
    case 'embedded':
      newType = DeviceTypeEnum.EMBEDDED_DEVICE
      break;
    case 'desktop':
      newType = DeviceTypeEnum.DESKTOP
      break;
    default:
      newType = DeviceTypeEnum.UNKNOWN
      break;
  }

  return newType
}
